<script setup lang="ts">
import type { PressSection } from '~/types/api'

defineProps<{
  modelValue: number
  sections: PressSection[]
}>()

const emit = defineEmits<{
  'update:modelValue': [nid: number]
}>()
</script>

<template>
  <nav class="w-full bg-neutral-100">
    <div
      class="container flex flex-col flex-wrap justify-center py-2 sm:flex-row sm:py-0"
    >
      <button
        v-for="section in sections"
        :key="section.nid"
        :class="{
          'bg-white !text-black': section.nid === modelValue,
        }"
        class="grow p-3.5 text-left text-[calc(1.275rem)] font-bold !leading-none tracking-tight text-neutral-300 transition-colors duration-300 hover:text-black sm:max-md:min-w-[50%] sm:max-md:max-w-[50%] md:max-lg:max-w-[30%] md:max-lg:basis-1/3 lg:py-7 lg:text-center xl:text-2xl"
        @click="emit('update:modelValue', section.nid)"
      >
        {{ section.title }}
      </button>
    </div>
  </nav>
</template>

<style scoped></style>
